const FEEDBACK_PAY_PER_UNIT = 5;
const TRAVEL_FEE_AMOUNT = 4;
const DEFAULT_COMMISSION = 5;

const formatNum = (n) => {
	const rounded = Math.round(n * 100) / 100;
	return Number.isInteger(rounded) ? String(rounded) : String(rounded);
};

const formatOneDecimal = (n) => {
	const rounded = Math.round(n * 10) / 10;
	return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1);
};

/** @param {number} nonInvoicedTotal */
export const calculateCommissionUnits = (nonInvoicedTotal) => {
	if (!nonInvoicedTotal) return 0;
	return Math.round((nonInvoicedTotal / 125) * 10) / 10;
};

/**
 * @param {{
 *   basePay: number,
 *   estimatedDays: number,
 *   nonInvoicedTotal: number,
 *   commission: number,
 *   travelCount: number,
 *   feedbackCount: number,
 *   bonus: boolean,
 * }} params
 */
export const buildPayFormula = ({
	basePay,
	estimatedDays,
	nonInvoicedTotal,
	commission,
	travelCount,
	feedbackCount,
	bonus,
}) => {
	const dayRate = basePay / 5;
	const dayAdjustment = (estimatedDays - 5) * dayRate;

	let inner = formatNum(basePay);
	if (dayAdjustment !== 0) {
		inner += dayAdjustment > 0 ? `+${formatNum(dayAdjustment)}` : formatNum(dayAdjustment);
	}
	const commissionRate = parseFloat(commission) || DEFAULT_COMMISSION;
	const commissionUnits = calculateCommissionUnits(parseFloat(nonInvoicedTotal) || 0);
	if (commissionUnits > 0 && commissionRate > 0) {
		inner += `+(${formatNum(commissionRate)}*${formatOneDecimal(commissionUnits)})`;
	}

	let formula = `=((${inner})`;
	if (bonus) {
		formula += "*110%";
	}
	formula += ")";

	if (travelCount > 0) {
		formula += `+(${TRAVEL_FEE_AMOUNT}*${travelCount})`;
	}

	const feedbackPay = feedbackCount * FEEDBACK_PAY_PER_UNIT;
	if (feedbackPay > 0) {
		formula += `+${formatNum(feedbackPay)}`;
	}

	return formula;
};

export {DEFAULT_COMMISSION, FEEDBACK_PAY_PER_UNIT, TRAVEL_FEE_AMOUNT};
